import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    listarTemplatesWpp,
    obterIntegracaoWpp,
    salvarIntegracaoWpp,
} from "../../../services/integracaoWhatsapp"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { IntegracaoWhatsappActionsTypes } from "./integracaoWhatsappActions"
import { IntegracaoWhatsappContext } from "./IntegracaoWhatsappContext"
import { IntegracaoWhatsappInicial, integracaoWhatsappReducer } from "./integracaoWhatsappReducer"

export function IntegracaoWhatsappContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(integracaoWhatsappReducer, IntegracaoWhatsappInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterIntegracaoWpp(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar integração")
            } else {
                setErroCarregamento(null)
                dispatch({ type: IntegracaoWhatsappActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar integração")
        } finally {
            setLoading(false)
        }
    }, [setLoading])

    const recarregarTemplates = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await listarTemplatesWpp(autorizacao)
            if (!("retornoErro" in response)) {
                dispatch({
                    type: IntegracaoWhatsappActionsTypes.CARREGAR_TEMPLATES,
                    payload: response,
                })
            }
        } finally {
            setLoading(false)
        }
    }, [setLoading])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await salvarIntegracaoWpp(autorizacao, {
                wabaid: dados.wabaid,
                ativo: dados.ativo,
            })
            if (!("retornoErro" in response)) {
                dispatch({ type: IntegracaoWhatsappActionsTypes.CONFIRMAR_SAVE, payload: response })
            }
        } finally {
            setLoading(false)
        }
    }, [dados.ativo, dados.wabaid, setLoading])

    useEffect(() => {
        carregar()
    }, [carregar])

    useEffect(() => {
        recarregarTemplates()
    }, [recarregarTemplates])

    return (
        <IntegracaoWhatsappContext.Provider
            value={{ dados, dispatch, erroCarregamento, salvar, recarregarTemplates }}
        >
            <Loading />
            {children}
        </IntegracaoWhatsappContext.Provider>
    )
}
